import { ExchangeButton, GraphChart } from '@dashboard'
import { useExchangePairsQry } from 'mmfintech-backend-api'
import './GraphSection.scss'

function GraphSection() {
  const { updatedFxRates } = useExchangePairsQry({
    fixedRates: null
  })

  return (
    <div className='graph-pane-wrapper'>
      <div className='graph'>
        <GraphChart />
      </div>

      <div className='exchange-pane-wrapper'>
        {updatedFxRates
          ?.filter((_node, index) => index < 4)
          .map((node, index) => (
            <ExchangeButton key={index} node={node} />
          ))}
      </div>
    </div>
  )
}

export default GraphSection
